import { MandatoryWaypoints } from "./MandatoryWaypoints.js";
export { MandatoryWaypointSequence };
class MandatoryWaypointSequence extends MandatoryWaypoints {
    constructor(sequence, nextIndex = 0) {
        super();
        this.sequence = sequence;
        this.nextIndex = nextIndex;
    }
    next() {
        if (this.isFinished()) {
            return undefined;
        }
        else {
            return this.sequence[this.nextIndex].next();
        }
    }
    isAllowed(waypoint) {
        return !this.isFinished() && this.sequence[this.nextIndex].isAllowed(waypoint);
    }
    moveNext(waypoint) {
        const c = this.sequence[this.nextIndex];
        c.moveNext(waypoint);
        if (c.isFinished()) {
            this.nextIndex++;
        }
    }
    isFinished() {
        return this.nextIndex === this.sequence.length;
    }
    clone() {
        return new MandatoryWaypointSequence(this.sequence.map(s => s.clone()), this.nextIndex);
    }
}
//# sourceMappingURL=MandatoryWaypointSequence.js.map